import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Building2, TrendingUp, Award } from 'lucide-react';

const AboutUsPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <WhatsAppButton />

      <section className="bg-white pt-24 sm:pt-28 md:pt-32 pb-16 sm:pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-10 sm:mb-12">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4 sm:mb-6 leading-[1.1]">
                About <span className="text-emerald-600">LOANYARD CAPITAL</span>
              </h1>
              <div className="max-w-3xl mx-auto">
                <p className="text-lg text-slate-700 leading-relaxed mb-4">
                  LOANYARD CAPITAL is a corporate finance firm delivering debt, equity, capital syndication, structured finance and M&amp;A solutions for HNIs, promoters, family businesses and corporates.
                </p>
                <p className="text-base text-slate-600 leading-relaxed">
                  We combine financial assessment, capital structuring, lender access, commercial negotiation and transaction execution to help clients identify and close appropriate financing solutions.
                </p>
              </div>
            </div>

            {/* Stats Grid */}
            <div className="grid md:grid-cols-3 gap-6 mb-12">
              <div className="bg-white p-6 rounded-xl shadow-lg border-2 border-slate-200 text-center">
                <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <Award className="w-7 h-7 text-emerald-600" />
                </div>
                <div className="text-3xl font-bold text-emerald-600 mb-2">15+</div>
                <div className="text-slate-600 font-medium">Years Experience</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-lg border-2 border-slate-200 text-center">
                <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <TrendingUp className="w-7 h-7 text-emerald-600" />
                </div>
                <div className="text-3xl font-bold text-emerald-600 mb-2">₹500+ Cr</div>
                <div className="text-slate-600 font-medium">Financing Facilitated</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-lg border-2 border-slate-200 text-center">
                <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <Building2 className="w-7 h-7 text-emerald-600" />
                </div>
                <div className="text-3xl font-bold text-emerald-600 mb-2">500+</div>
                <div className="text-slate-600 font-medium">Client Transactions</div>
              </div>
            </div>

            {/* Mission & Values */}
            <div className="grid md:grid-cols-3 gap-8">
              <div id="mission" className="bg-white p-8 rounded-2xl shadow-lg border-2 border-slate-200 hover:border-emerald-500 transition-all duration-300 scroll-mt-24">
                <h2 className="text-2xl font-bold text-slate-900 mb-4">Our Mission</h2>
                <p className="text-slate-600 leading-relaxed">
                  To empower individuals and businesses with accessible financial solutions that help them achieve their dreams and goals with confidence.
                </p>
              </div>
              <div id="vision" className="bg-white p-8 rounded-2xl shadow-lg border-2 border-slate-200 hover:border-emerald-500 transition-all duration-300 scroll-mt-24">
                <h2 className="text-2xl font-bold text-slate-900 mb-4">Our Vision</h2>
                <p className="text-slate-600 leading-relaxed">
                  To become India's most trusted loan advisory firm by delivering unparalleled service, transparency, and financial expertise to every client.
                </p>
              </div>
              <div id="values" className="bg-white p-8 rounded-2xl shadow-lg border-2 border-slate-200 hover:border-emerald-500 transition-all duration-300 scroll-mt-24">
                <h2 className="text-2xl font-bold text-slate-900 mb-4">Our Values</h2>
                <p className="text-slate-600 leading-relaxed">
                  Integrity, transparency, customer-first approach, and commitment to excellence guide everything we do for our clients.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutUsPage;
